import {apiGetCall, apiPostCall} from "./index";

export const load   = language => apiGetCall("/help/getall", {language});
export const save   = (uuid, itemDetails) => apiPostCall("/help/save", {uuid, ...itemDetails}, true, true);
export const remove = (uuid, language) => apiPostCall("/help/remove", {uuid, language});